import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  type ButtonProps,
} from '@mui/material'
import { colorPrimitives, white } from './Theme'

interface ActivityButtonProps {
  active: boolean
  icon?: React.ReactNode
}

export const ActivityButton = ({
  active,
  icon,
  variant,
  children,
  ...buttonProps
}: ActivityButtonProps & ButtonProps) => {
  const progressBarColorOverride = variant === 'contained' ? white : undefined

  const showIconButton = !!icon

  const progress = (
    <CircularProgress
      size={showIconButton ? 16 : 24}
      color="primary"
      sx={{ color: progressBarColorOverride }}
    />
  )

  return showIconButton ? (
    <Box position="relative">
      {active ? (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{ transform: 'translate(-50%, -50%)' }}
        >
          {progress}
        </Box>
      ) : (
        <IconButton onClick={buttonProps.onClick}>
          <Box
            sx={{
              color: colorPrimitives.redGaming,
              opacity: active ? 0 : 1,
              width: 32,
              height: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </IconButton>
      )}
    </Box>
  ) : (
    <Button variant={variant} {...buttonProps} sx={{ position: 'relative' }}>
      <Box sx={{ opacity: active ? 0 : 1 }}>{children}</Box>
      {active && (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{ transform: 'translate(-50%, -50%)' }}
        >
          {progress}
        </Box>
      )}
    </Button>
  )
}
